import * as types from './Types.js';

export function findRegulamentacoes(filter) {
  return ({ fetch }) => ({
    type: types.REGULAMENTACOES,
    payload: fetch(`/api/regulamentacoes?${filter}`)
  });
}
